// extracted by mini-css-extract-plugin
export default {"root":"IconPayout_root__ms8zI"};